import "./App.css";
import Navbar from "./components.js/Navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./components.js/Footer";
import Home from "./components.js/Home";
import ProductDetails from "./components.js/ProductDetail";
import { CartProvider } from "./components.js/cartContext";
import { WishlistProvider } from "./components.js/Wishlistcontext";
import Cart from "./components.js/Cart";
import Checkout from "./components.js/Checkout";
import Wishlist from "./components.js/Wishlist";
import ReturnAndRefund from "./components.js/Return_Refund";
import PrivacyPolicy from "./components.js/Privacy_policy";
import TermsAndConditions from "./components.js/Terms";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CategoryPage from "./components.js/CategoryPage";
import FaqPage from "./components.js/FAQs";
import BlogPostsPage from "./components.js/BlogPostsPage";
import Contact from "./components.js/Contact";
import BlogListPage from "./components.js/BlogListPage";
import AboutPage from "./components.js/AboutPage";
import NewsletterPage from "./components.js/Newsletter";
import UnsubscribePage from "./components.js/Unsubscribe";
import { SearchProvider } from "./components.js/SearchContext";
import Search from "./components.js/Search";
import { CurrencyProvider } from "./components.js/CurrencyContext";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <CurrencyProvider>
      <SearchProvider>
        <WishlistProvider>
          <CartProvider>
            <Router>
              <ScrollToTop />
              <Navbar />

              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/faqs" element={<FaqPage />} />
                <Route path="/blog/" element={<BlogListPage />} />
                <Route path="/blog/:title" element={<BlogPostsPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/newsletter" element={<NewsletterPage />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/privacy_policy" element={<PrivacyPolicy />} />
                <Route path="/return_refund" element={<ReturnAndRefund />} />
                <Route
                  path="/categories/:category"
                  element={<CategoryPage />}
                />
                {/* <Route path="/categories/:category" element={<CategoryPage />} /> */}
                <Route path="/search" element={<Search />} />
                <Route
                  path="/productinfo/:id/:category"
                  element={<ProductDetails />}
                />
              </Routes>

              <Footer />
            </Router>
          </CartProvider>
        </WishlistProvider>
      </SearchProvider>
    </CurrencyProvider>
  );
}

export default App;
